<!-- 配置中心 -->
<template>
    <div class="basis-page-cls">
        <section class="basis-cls_filter">
            <table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 品牌列表</span>
                <div class="btns">
                    <el-button v-if="userInfo.userType == '1'" size="small" type="primary" icon="el-icon-plus" @click="addBrand()" class="right">新增品牌</el-button>
                </div>
            </div>
            <div class="table">
                <table-pagination
                    ref="expandTable"
                    pagination
                    row-key="brandId"
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNumber"
                    :limit.sync="listQuery.pageSize"
                    lazy
                    :load="load"
                    :tree-props="{children: 'menuList',hasChildren:'hasChildren'}"
                    @pagination="getBrandList" />
            </div>
        </section>

        <customMenuList ref="customMenuList"/>
        <setLicense ref="setLicense"/>
        <uploadLicense ref="uploadLicense"/>
        <brandManage ref="brandManage" @handleDone="refreshTree"/>
        <larkUrlManage @onEmitUpload="getBrandList" ref="larkUrlManage"/>
        <MFAOption ref="MFAOption" @handleDone="getBrandList"/>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import customMenuList from './components/customMenu'; // 自定义菜单
    import setLicense from "./components/licenseManage/setLicense"; // 设置license
    import uploadLicense from "./components/licenseManage/uploadLicense"; // 上传license
    import brandManage from "./components/brandManage"; // 新增修改品牌
    import larkUrlManage from "./components/larkUrlManage"; // 新改larkUrl
    import MFAOption from "./components/MFAOption"; // MFA设置

    export default {
        components: {
            customMenuList,
            setLicense,
            uploadLicense,
            brandManage,
            larkUrlManage,
            MFAOption
        },
        data() {
            return {
                list: [],
                total: 0,
                // -----头部查询-----
                filterHeader: [
                    { label: '品牌标识', model: 'brandIdentify', type: 'input', default: '', placeholder: "请输入品牌标识"},
                    { label: '品牌名称', model: 'brandName', type: 'input', default: '', placeholder: "请输入品牌名称"}
                ],
                listQuery: {
                    pageSize: 10,
                    pageNumber: 1,
                    brandIdentify: "",
                    brandName: "",
                },
                // -----表格数据-----------------------------
                column: [
                    {
                        label: '品牌标识',
                        minWidth: 120,
                        render: (h, scope) => {
                            return (
                                <span>
                                {
                                    !scope.row.needIndents &&
                                    <div class="indents" style={{
                                        display: "inline-block",
                                        width: "23px",
                                        // height: "20px",
                                    }}></div>
                                }
                                    {scope.row.brandIdentify}
                                </span>
                            )
                        }
                    },
					{ label: '品牌名称', prop: 'brandName', minWidth: 120 },
					{ label: '创建时间', prop: 'createTime', minWidth: 150 },
					{ label: '备注', prop: 'remarks', minWidth: 150 },
					 {
                        label: 'LarkUrl',
                        minWidth: 120,
                        render: (h, scope) => {
                            return (
                                <span>
                                { scope.row.larkUrl ? '已配置' : '未配置'}
                                </span>
                            )
                        }
                    },
					{
	                    label: '操作',
	                    prop: 'cation',
	                    align: 'center',
	                    width: 290,
	                    fixed: 'right',
	                    render: (h, scope) => {
							return (
								<div>
									<el-button type="text" onClick={()=>this.editBrand(scope.row)}>修改</el-button>
									{
										!scope.row.parentBrandIdentify &&<el-button type="text" onClick={()=>this.addSubBrand(scope.row)} icon="el-icon-plus">品牌</el-button>
									}
									<el-button type="text" onClick={()=>this.customMenuList(scope.row)}>自定义菜单</el-button>
                                   
                                    <el-dropdown>
                                        <span class="el-dropdown-link" style="margin-left: 10px;">
                                            <el-button type="text">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            {
                                                (!scope.row.parentBrandIdentify && (this.userInfo.userType == 2 || this.userInfo.userType == 1)) &&
                                                <el-dropdown-item nativeOnClick={()=>this.setMFA(scope.row)}>
                                                    <el-button type="text">登录验证设置</el-button>
                                                </el-dropdown-item>
                                            }
                                            {	
                                                (!scope.row.parentBrandIdentify) &&
                                                <el-dropdown-item nativeOnClick={()=>this.setChannel(scope.row)}>
                                                    <el-button type="text">渠道管理</el-button>
                                                </el-dropdown-item>
                                            }
                                            {
                                                (!scope.row.parentBrandIdentify && this.userInfo.userType == 1) &&
                                                <el-dropdown-item nativeOnClick={()=>this.setLicense(scope.row)}>
                                                    <el-button type="text">license管理</el-button>
                                                </el-dropdown-item>
                                            }
                                            {
                                                !scope.row.parentBrandIdentify &&
                                                <el-dropdown-item nativeOnClick={()=>this.uploadLicense(scope.row)}>
                                                <el-button type="text" >license上传</el-button>
                                                </el-dropdown-item>
                                            }
                                            {
                                                (!scope.row.parentBrandIdentify && this.userInfo.userType == 1) &&
                                                <el-dropdown-item nativeOnClick={()=>this.updateLarkUrl(scope.row)}>
                                                <el-button type="text">lark URL</el-button>
                                                </el-dropdown-item>
                                            } 
                                            {
                                                this.userInfo.userType == '1' && 
                                                <el-dropdown-item nativeOnClick={()=>this.delBrand(scope.row)}>
                                                <el-button type="text">删除</el-button>
                                                </el-dropdown-item>
                                            }
                                        </el-dropdown-menu>
                                    </el-dropdown>
								</div>
							)
	                    }
	                }
	            ],
            	// -----------------------------------------------------
            }
        },
        computed: {
            ...mapGetters([
                'userInfo',
                'needCreateSubBrand'
            ])
        },
        mounted() {
            this.getBrandList();
            this.checkNeedCreateSubBrand();
        },
        methods: {
            /**
             * 查看是否是needCreateSubBrand是不是没有子品牌的品牌管理员登录
             * 强制添加子品牌
             */
            checkNeedCreateSubBrand(){
                if(this.needCreateSubBrand){
                    this.addSubBrand({
                        brandIdentify: this.userInfo.brandIdentify
                    })
                }
            },

            filterSearch(query){
                this.listQuery = Object.assign(this.listQuery, query);
                this.getBrandList();
            },
            // 打开license弹窗
            setLicense(row){
                this.$refs.setLicense.open(row);
            },
            // 打开license弹窗
            uploadLicense(row){
                this.$refs.uploadLicense.openUpload(row.brandIdentify,row.brandName);
            },

            load(row, treeNode, resolve) {
				this.$api.getBrandSel({
					data: {
						// brandIdentify: this.listQuery.brandIdentify,
						brandName: this.listQuery.brandName,
						parentBrandIdentify: row.brandIdentify,
					},
					orderBy: "",
					pageNum: '1',
					pageSize: '50'
				}).then(res => {
                    if(res.errcode != 0) return false;
					if (res.list.length <= 0) {
						resolve([]);
						this.$message.error("未查询到子品牌");
						return;
					}
					resolve(res.list);
				});
			},

            // 新增子品牌
            addSubBrand (row) {
                this.$refs.brandManage.open("addSubBrand", row);
            },
            //新增品牌
            addBrand() {
                this.$refs.brandManage.open("addBrand");
            },
            // 编辑品牌
            editBrand(row) {
                this.$refs.brandManage.open("updateBrand", row);
            },
			setChannel(row) {
				this.$router.push({name: `brandChannel`, params: {brand: row.brandIdentify}});
			},
            setMFA(row) {
                this.$refs.MFAOption.open(row);
            },

            // 删除品牌
            delBrand(param) {
                this.$confirm('一旦删除，该品牌将永久消失。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error',
                }).then(() => {
                    this.removeBrand(param)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            removeBrand(param) {
                this.$api.deleteBrandS(param.brandId).then(res => {
                    if(res.errcode != 0) return false;
                    this.getBrandList()

                })
            },

            // 打开自定义菜单
            customMenuList(row) {
                this.$refs.customMenuList.openCustomMenu(row);
            },
            
            // 更新larkUrl
            updateLarkUrl(row){
                this.$refs.larkUrlManage.open(row);
            },

            getBrandList() {
                this.$api.getBrandSel({
                    data: {
                        brandIdentify: this.listQuery.brandIdentify,
                        brandName: this.listQuery.brandName
                    },
                    orderBy: "",
                    pageNum: this.listQuery.pageNumber,
                    pageSize: this.listQuery.pageSize
                }).then(res => {
                    if(res.errcode != 0) return false;
                    this.list = res.list
                    this.list.forEach(val => {
                        val.needIndents = val.subBrandCount>0;
                        val.hasChildren = true;
                    });
                    this.total = res.total
                    this.refreshTree();
                })
            },

            // 请求品牌列表,重置表格展开状态
            refreshTree(){
                let tableRef = this.$refs.expandTable.$refs.elTable;
                for(let brandData of this.list){
                    let key = brandData.brandId;
                    if(tableRef['store'].states.treeData[key]){
                        tableRef['store'].states.treeData[key].loaded = false
                        tableRef['store'].states.treeData[key].expanded = false
                    }
                }
                this.$nextTick(function(){
                    let expandIcon = tableRef.$el.querySelectorAll(".el-table__expand-icon");
                    this.list.forEach((rowData,index ) => {
                        if (rowData.subBrandCount <= 0) {
                            expandIcon[index].setAttribute("style", "display:none");
                        } else {
                            expandIcon[index].setAttribute("style", "display:inline-block");
                        }
                    });
                })

            }
        }
    }
</script>

<style lang="scss" scoped>
.indents{
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 3px;
    background: red;
}
</style>